import React, { useRef, useLayoutEffect, useEffect, useState, useContext } from 'react'
import videojs, { VideoJsPlayer } from 'video.js'
import 'video.js/dist/video-js.css'

export interface PlaybackContext {
  currentTime: number
  setCurrentTime: (value: number) => void
}

export const PlaybackContext = React.createContext<PlaybackContext>({
  currentTime: 0,
  setCurrentTime: (v) => null
})

export const PlaybackContextProvider: React.FC = ({children}) => {
  const [ currentTime, setCurrentTime ] = useState<number>(0)

  return <PlaybackContext.Provider value={{ currentTime, setCurrentTime }}>
    {children}
  </PlaybackContext.Provider>
}

export interface VideoPlayerProps extends videojs.PlayerOptions {
  onError?: (player: VideoJsPlayer) => void
  // onTimeUpdate?: (player: VideoJsPlayer, event: Event) => void
}

const VideoPlayer: React.FC<VideoPlayerProps> = (props) => {
  const videoNodeRef = useRef<HTMLVideoElement>(null)
  const playerRef = useRef<VideoJsPlayer>()
  const propsRef = useRef<VideoPlayerProps>(props)

  const { setCurrentTime } = useContext(PlaybackContext)
  const { tracks, onError } = props

  useLayoutEffect(() => {
    let player: VideoJsPlayer

    const onPlayerReady = () => {
      // console.log('onPlayerReady', player)
    }

    player = videojs(videoNodeRef.current, propsRef.current, onPlayerReady)
    player.on('error', () => {
      if (onError)
        onError(player)
    })
    player.on('timeupdate', (event) => {
      setCurrentTime(player.currentTime())
    })
    playerRef.current = player

    return () => {
      player.dispose()
    }
  }, [ videoNodeRef, propsRef, onError, setCurrentTime ])

  useEffect(() => {
    if (!playerRef.current) return

    if (tracks && tracks.length > 0) {
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i]
        playerRef.current.addRemoteTextTrack(track, false)
      }
    }
  }, [ tracks ])

  return <div>
    <div data-vjs-player>
      <video ref={videoNodeRef} className="video-js" />
    </div>
  </div>
}

export default VideoPlayer
